import type { FaireProductEntity } from "../../entity_types/product";

export const p_9sj2gkmu23: FaireProductEntity = {
  token: "p_9sj2gkmu23",
  type: "product",
  name: "Brown Bear Cardigan for Baby & Toddler",
  brandToken: "b_e6gi5qy7n8",
  brandName: "Huggalugs",
  imageUrl:
    "https://cdn.faire.com/fastly/f0361837e1f9fe447906b69cdd3ed827e5aa7a7f9f673d8f3999f30d213ee915.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a5369b1fd83c6445bf2745d03a9c522228dc287b9157a799e4d35fe92e275f75.png",
    "https://cdn.faire.com/fastly/703a86f8320c1327ee89dc4b6028827b5c931034587b5d545cf075192e390452.png",
  ],
  priceDollars: 24,
  description:
    "This adorable cardigan sweater features bear‑face pockets that little ones will love. Hand‑knit in cozy Oatmeal yarn with dark‑brown pocket accents, it pairs perfectly with our Brown Bear Beanie for the cutest coordinated look. A wonderful gift for a new baby or birthday, and such a fun outfit for your next outdoor adventure.\n\nOur sweaters are crafted using recycled, sustainable polyester yarn spun from reclaimed plastic bottles, a thoughtful choice that helps lessen global plastic waste. It’s one small way we’re contributing to a cleaner, more sustainable world. ♻️\n\n• Hand Knit\n• 60% Acrylic, 40% Recycled Polyester\n• Hand Wash\n• Designed in our Coachella Valley, CA studio\n\n",
  tags: [],
  msrpDollars: 48,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:55.683Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
